// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// import { Row, Col, Form } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

// const LeadView = ({ data, leadId, setLeadDetails }) => {
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [editedLeadData, setEditedLeadData] = useState(data);
//     const [organisations, setOrganisations] = useState([]);
//     const [contacts, setContacts] = useState([]);
//     const didFetchRef = useRef(false);

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchOrganisations();
//             fetchContacts();
//             didFetchRef.current = true;
//         }
//     }, []);

//     const fetchOrganisations = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');

//             const response = await axios.get(`${backendUrl}/api/organisation`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`, 'Tenant-Origin': origin,
//                 },
//             });
//             setOrganisations(response.data.data);
//         } catch (error) {
//             console.error("Error fetching organisations:", error);
//         }
//     };

//     const fetchContacts = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');

//             const response = await axios.get(`${backendUrl}/api/contact`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             setContacts(response.data.Data);
//         } catch (error) {
//             console.error("Error fetching contacts:", error);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         setEditedLeadData((prevState) => {
//             const updatedData = { ...prevState, [name]: value };

//             // Reset contact_id when lead_source changes
//             if (name === "lead_source") {
//                 updatedData.contact_id = "";
//             }

//             return updatedData;
//         });
//     };

//     const handleSave = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const token = JSON.parse(localStorage.getItem("user-info"))?.token;
//             const origin = localStorage.getItem('user-origin');

//             await axios.put(`${backendUrl}/api/leads/${leadId}`, editedLeadData, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });
//             setLeadDetails((prevDetails) => ({
//                 ...prevDetails,
//                 ...editedLeadData,
//             }));
//             setEditField(null);
//         } catch (error) {
//             console.error("Error saving lead details:", error);
//         }
//     };
//     const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');
//     const getPartnerName = (id) => {
//         if (!id) return "--";
//         const partner = partnerOrganisations.find((p) => Number(p.id) === Number(id));
//         return partner ? partner.name : "--";
//     };
//     const getOrgName = (id) => {
//         if (!id) return "--";
//         const contact = organisations.find((c) => Number(c.id) === Number(id));
//         return contact ? contact.name : "--";
//     };
//     const getContactName = (id) => {
//         if (!id) return "--";
//         const contact = contacts.find((c) => Number(c.id) === Number(id));
//         return contact ? contact.name : "--";
//     };
//     const fields = [
//         { name: "name", label: "Lead Name", type: "text" },
//         { name: "organisation_id", label: "Organisation", type: "select", options: organisations.map(org => ({ value: org.id, label: org.name })) },
//         {
//             name: "lead_source",
//             label: "Lead Source",
//             type: "select",
//             options: [
//                 { value: "consultant", label: "Consultant" },
//                 { value: "partner", label: "Partner" },
//                 { value: "inside sales", label: "Inside Sales" },
//                 { value: "sales generated", label: "Sales Generated" }
//             ]
//         },
//         { name: 'partner_id', label: 'Partner Name', type: 'select', options: partnerOrganisations.map(partner => ({ value: partner.id, label: partner.name })) },
//         {
//             name: "contact_id",
//             label: "Contact",
//             type: "select",
//             options: (() => {
//                 const leadSource = editedLeadData.lead_source?.toLowerCase();

//                 if (leadSource === "partner" && editedLeadData.partner_id) {
//                     const partnerOrganisation = organisations.find(
//                         org => String(org.id) === String(editedLeadData.partner_id)
//                     );
//                     if (partnerOrganisation?.org_type?.toLowerCase() === "partner") {
//                         return (partnerOrganisation.contacts || []).map(contact => ({
//                             value: contact.id,
//                             label: contact.name
//                         }));
//                     }
//                 }
//                 else if (leadSource === "consultant") {
//                     return contacts
//                         .filter(contact =>
//                             contact.contact_type?.toLowerCase() === "external" &&
//                             (contact.type?.name?.toLowerCase() || "") === "consultant"
//                         )
//                         .map(contact => ({ value: contact.id, label: contact.name }));
//                 }
//                 else if (leadSource === "inside sales") {
//                     return contacts
//                         .filter(contact =>
//                             contact.contact_type?.toLowerCase() === "internal" &&
//                             (contact.type?.name?.toLowerCase() || "") === "inside sales"
//                         )
//                         .map(contact => ({ value: contact.id, label: contact.name }));
//                 }
//                 else if (leadSource === "sales generated") {
//                     return contacts
//                         .filter(contact =>
//                             contact.contact_type?.toLowerCase() === "internal" &&
//                             (contact.type?.name?.toLowerCase() || "") === "sales generated"
//                         )
//                         .map(contact => ({ value: contact.id, label: contact.name }));
//                 }
//                 else {
//                     const selectedOrg = organisations.find(
//                         org => String(org.id) === String(editedLeadData.organisation_id)
//                     );
//                     return (selectedOrg?.contacts || []).map(contact => ({
//                         value: contact.id,
//                         label: contact.name
//                     }));
//                 }

//                 return [];
//             })()
//         },

//         { name: "notes", label: "Notes", type: "text" },
//     ];
//     const [editField, setEditField] = useState(null);

//     const visibleFields = fields.filter((field) => {
//         if (field.name === "partner_id") {
//             return editedLeadData.lead_source === "partner";
//         }
//         if (field.name === "contact_id") {
//             return ["partner", "consultant", "inside sales", "sales generated"].includes(editedLeadData.lead_source);
//         }
//         return true;
//     });
//     return (
//         <div className="p-3 font-size-13">
//             <Row>
//                 {visibleFields.map((field, index) => (
//                     <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
//                         <strong className="view-label">
//                             {field.label}:
//                         </strong>
//                         <div className="editable-container d-flex align-items-center">
//                             {editField === field.name ? (
//                                 <div className="d-flex align-items-center">
//                                     {field.type === "select" ? (
//                                         <Form.Select
//                                             name={field.name}
//                                             value={editedLeadData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                         >
//                                             <option value="">Select</option>
//                                             {field.options.map((option) => (
//                                                 <option key={option.value} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </Form.Select>
//                                     ) : (
//                                         <Form.Control
//                                             type="text"
//                                             name={field.name}
//                                             value={editedLeadData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                         />
//                                     )}
//                                     <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
//                                     <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
//                                 </div>
//                             ) : (
//                                 <div className="hover1" onClick={() => setEditField(field.name)}>
//                                     <span className="hover-field1">
//                                         {field.name === "partner_id" ? getPartnerName(editedLeadData[field.name]) :
//                                             field.name === "contact_id" ? getContactName(editedLeadData[field.name]) :
//                                                 field.name === "organisation_id" ? getOrgName(editedLeadData[field.name]) :
//                                                     editedLeadData[field.name] || "--"}
//                                     </span>
//                                     <BsPencil className="text-primary pencil-icon1" />
//                                 </div>
//                             )}
//                         </div>
//                     </Col>
//                 ))}
//             </Row>
//         </div>
//     );
// };



// export default LeadView;

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import { Row, Col, Form, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const LeadView = ({ data, leadId, setLeadDetails }) => {
    const [editedLeadData, setEditedLeadData] = useState(data);
    const [organisations, setOrganisations] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [editField, setEditField] = useState(null);
    const [hoveredField, setHoveredField] = useState(null);
    const didFetchRef = useRef(false);

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchOrganisations();
            fetchContacts();
            didFetchRef.current = true;
        }
    }, []);

    useEffect(() => {
        if (data) {
            setEditedLeadData(data);
        }
    }, [data]);

    const fetchOrganisations = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                                skipLoader:true,

            });
            setOrganisations(response.data.data);
        } catch (error) {
            console.error("Error fetching organisations:", error);
        }
    };

    const fetchContacts = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/contact`, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                                skipLoader:true,

            });
            setContacts(response.data.Data);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedLeadData((prevState) => {
            const updatedData = { ...prevState, [name]: value };
            if (name === "lead_source") {
                updatedData.contact_id = "";
            }
            return updatedData;
        });
    };

    const handleSave = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const token = JSON.parse(localStorage.getItem("user-info"))?.token;
            const origin = localStorage.getItem('user-origin');

            await axios.put(`${backendUrl}/api/leads/${leadId}`, editedLeadData, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            setLeadDetails((prevDetails) => ({
                ...prevDetails,
                ...editedLeadData,
            }));
            setEditField(null);        
        } catch (error) {
            console.error("Error saving lead details:", error);
        }
    };

    const partnerOrganisations = organisations?.filter(org => org.org_type === 'partner');
    
    const getPartnerName = (id) => {
        if (!id) return "--";
        const partner = partnerOrganisations.find((p) => Number(p.id) === Number(id));
        return partner ? partner.name : "--";
    };
    
    const getOrgName = (id) => {
        if (!id) return "--";
        const org = organisations.find((o) => Number(o.id) === Number(id));
        return org ? org.name : "--";
    };
    
    const getContactName = (id) => {
        if (!id) return "--";
        const contact = contacts.find((c) => Number(c.id) === Number(id));
        return contact ? contact.name : "--";
    };

    const fields = [
        { name: "name", label: "Lead Name", type: "text" },
        { name: "organisation_id", label: "Organisation", type: "select", options: organisations.map(org => ({ value: org.id, label: org.name })) },
        { 
            name: "lead_source", 
            label: "Lead Source", 
            type: "select", 
            options: [
                { value: "consultant", label: "Consultant" },
                { value: "partner", label: "Partner" },
                { value: "inside sales", label: "Inside Sales" },
                { value: "sales generated", label: "Sales Generated" }
            ] 
        },
        { name: 'partner_id', label: 'Partner Name', type: 'select', options: partnerOrganisations.map(partner => ({ value: partner.id, label: partner.name })) },
        {
            name: "contact_id",
            label: "Contact",
            type: "select",
            options: (() => {
                const leadSource = editedLeadData.lead_source?.toLowerCase();
                
                if (leadSource === "partner" && editedLeadData.partner_id) {
                    const partnerOrganisation = organisations.find(
                        org => String(org.id) === String(editedLeadData.partner_id)
                    );
                    if (partnerOrganisation?.org_type?.toLowerCase() === "partner") {
                        return (partnerOrganisation.contacts || []).map(contact => ({
                            value: contact.id,
                            label: contact.name
                        }));
                    }
                } 
                else if (leadSource === "consultant") {
                    return contacts
                        .filter(contact => 
                            contact.contact_type?.toLowerCase() === "external" &&
                            (contact.type?.name?.toLowerCase() || "") === "consultant"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                } 
                else if (leadSource === "inside sales") {
                    return contacts
                        .filter(contact => 
                            contact.contact_type?.toLowerCase() === "internal" &&
                            (contact.type?.name?.toLowerCase() || "") === "inside sales"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                } 
                else if (leadSource === "sales generated") {
                    return contacts
                        .filter(contact => 
                            contact.contact_type?.toLowerCase() === "internal" &&
                            (contact.type?.name?.toLowerCase() || "") === "sales generated"
                        )
                        .map(contact => ({ value: contact.id, label: contact.name }));
                } 
                else {
                    const selectedOrg = organisations.find(
                        org => String(org.id) === String(editedLeadData.organisation_id)
                    );
                    return (selectedOrg?.contacts || []).map(contact => ({
                        value: contact.id,
                        label: contact.name
                    }));
                }
                
                return [];
            })()
        },
        { name: "notes", label: "Notes", type: "textarea" },
    ];

    const visibleFields = fields.filter((field) => {
        if (field.name === "partner_id") {
            return editedLeadData.lead_source === "partner";
        }
        if (field.name === "contact_id") {
            return ["partner", "consultant", "inside sales", "sales generated"].includes(editedLeadData.lead_source);
        }
        return true;
    });

    const getDisplayValue = (field, value) => {
        if (!value) return "--";
        
        switch (field.name) {
            case "partner_id":
                return getPartnerName(value);
            case "contact_id":
                return getContactName(value);
            case "organisation_id":
                return getOrgName(value);
            default:
                return value || "--";
        }
    };

    return (
        <div className="p-3">
            <Card className="border-0 shadow-sm">
                <Card.Header className="bg-white border-bottom py-3">
                    <h6 className="mb-0 fw-bold text-dark">Lead Information</h6>
                    <small className="text-muted">Manage lead details and properties</small>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="p-3">
                        <Row>
                            {visibleFields.map((field, index) => (
                                <Col md={6} key={index} className="mb-3">
                                    <div 
                                        className="lead-field-card p-3 border rounded h-100"
                                        onMouseEnter={() => setHoveredField(field.name)}
                                        onMouseLeave={() => setHoveredField(null)}
                                        style={{ 
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            backgroundColor: hoveredField === field.name ? '#f8f9fa' : 'white'
                                        }}
                                    >
                                        <div className="d-flex justify-content-between align-items-start">
                                            <div className="flex-grow-1">
                                                <label className="form-label text-muted small mb-2 fw-semibold">
                                                    {field.label}
                                                </label>
                                                {editField === field.name ? (
                                                    <div className="d-flex align-items-center gap-2 mt-2">
                                                        {field.type === "select" ? (
                                                            <Form.Select
                                                                name={field.name}
                                                                value={editedLeadData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                                size="sm"
                                                            >
                                                                <option value="">Select {field.label}</option>
                                                                {field.options.map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        ) : field.type === "textarea" ? (
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={2}
                                                                name={field.name}
                                                                value={editedLeadData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                            />
                                                        ) : (
                                                            <Form.Control
                                                                type={field.type}
                                                                name={field.name}
                                                                value={editedLeadData[field.name] || ""}
                                                                onChange={handleChange}
                                                                autoFocus
                                                                className="form-control-sm"
                                                            />
                                                        )}
                                                        {/* <div className="d-flex gap-1">
                                                            <BsCheck 
                                                                className="text-success" 
                                                                onClick={handleSave} 
                                                                style={{ cursor: "pointer", fontSize: "18px" }} 
                                                            />
                                                            <BsX 
                                                                className="text-danger" 
                                                                onClick={() => setEditField(null)} 
                                                                style={{ cursor: "pointer", fontSize: "18px" }} 
                                                            />
                                                        </div> */}
                                                    </div>
                                                ) : (
                                                    <div 
                                                        className="editable-field d-flex align-items-center justify-content-between mt-1"
                                                    >
                                                        <span className="text-dark fw-semibold">
                                                            {getDisplayValue(field, editedLeadData[field.name])}
                                                        </span>
                                                        {/* <BsPencil 
                                                            className="text-primary ms-2" 
                                                            size={14} 
                                                            style={{ 
                                                                opacity: hoveredField === field.name ? 1 : 0,
                                                                transition: 'opacity 0.2s ease'
                                                            }} 
                                                        /> */}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default LeadView;


